<p>
    {{ task.RequiredCashBalance }}
    <img src="assets/images/icons/icon-critter-coin.svg" class="text-icon invert" />
</p>
